import React from 'react'
import { MDBCard } from 'mdb-react-ui-kit'
import classes from './ProductBox.module.css'
import { Link } from 'react-router-dom'

import arrowWhite from '../../assets/img/arrow-white.svg'

export default function ProductBox({ image, link, alt }) {
  return (
    <MDBCard className={`bg-pays-dark font-white text-center mx-1 mx-lg-3 ${classes.productBox}`} >
      <div className={classes.productImageContainer}
      >
        <img
          src={image}
          alt="Google Play Card"
          className={`mx-auto ${classes.productImage}`}
        />
      </div>
        <Link className={` ${classes.link} font-white fw-bold translate-middle d-flex justify-content-center w-100`} to={link}>
          <span>Details ansehen</span><img src={arrowWhite} alt={alt} className="ms-1" />
        </Link>
    </MDBCard>
  )
}
